import i18n from "../i18n";
import NAME_SPACES from "./nameSpaces";

export function TranslationGlobal(key: any): string {
    const keyGlobal: any = `${NAME_SPACES.GLOBAL}:${key}`
    return i18n.t(keyGlobal);
}